/**
 * Util類
 */
export default {
    methods: {
        getIndex: function(list, key, addnum){
            // objectの何番目のキーであるかを返す。
            let retidx = 0 + addnum;
            Object.keys(list).some(function(i){
                if(i===key) {
                return true;
                }
                retidx++;
            });
            return retidx;
        },
        getKeyByStartStr: function(list, startstr) {
            // listからkeyがstartstrで始まる情報を取得する(1件)
            return list.find(item => item.startsWith(startstr));
        },
        convertAndSortObject: function (list) {
            // selectなどで、未選択の場合keyが文字列(--など)だが、他選択は数値となる場合に、
            // js仕様で 数値->文字列 の順に並んでしまうので、文字列->数値の順で並べられるよう
            // ソートしたObjectで返す
            var array = Object.keys(list).map((k)=>({ key: k, value: list[k] }));
            array.sort(function(prev, next) {
                var ret = 0;
                if(isNaN(prev.key) || (prev.key === '')) {
                ret = -1;
                } else if(isNaN(next.key)|| (prev.key === '')) {
                ret = 1;
                }
                return ret;
            });
            return array;
        },
        convertHankaku: function (str) {
            return str.replace(/[－ー]/g, "-")
                    .replace(/[！-～]/g, function(s) {
                        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
                    });
        },
        convertZenkakuKatakana: function (str) {
            return str.replace(/[ぁ-ん]/g, function(s) {
                        return String.fromCharCode(s.charCodeAt(0) + 0x60);
                    }).replace(/[｡-ﾟ]/g, function(s) {
                        var HankakuMap = {
                            'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
                            'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
                            'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
                            'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
                            'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
                            'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
                            'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
                            'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
                            'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
                            'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
                            'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
                            'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
                            'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
                            'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
                            'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
                            'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
                            'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
                            'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
                            '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
                        };
                        
                        var reg = new RegExp('(' + Object.keys(HankakuMap).join('|') + ')', 'g');
                        return s
                            .replace(reg, function (match) {
                                return HankakuMap[match];
                            })
                            .replace(/ﾞ/g, '゛')
                            .replace(/ﾟ/g, '゜');
                        }
                    );
        },
        convertHankakuZip: function (str) {
            let zip   = this.convertHankaku(str);
            if( this.isNumeric(zip) && zip.length === 7) {
              zip = zip.slice(0, 3) + '-' + zip.slice(3);
            }
            return zip;
        },
        delZen: function (input) {
            return input.replace(/[^\x20-\x7E]/g, '');
        },
        isKatakanaOrSpace: function(str) {
            const pattern = /^[\u30A0-\u30FF 　]+$/; // カタカナ（\u30A0-\u30FF）と全角スペース（\u3000）の範囲を指定
            return pattern.test(str);
        },
        isHalfWidthDigits: function(str) {
            const pattern = /^[0-9]+$/;
            return pattern.test(str);
        },
        isHalfWidthDigitsAndHyphen: function(str) {
            const pattern = /^[\d\-]+$/;
            return pattern.test(str);
        },
        isAlphanumeric: function(str) {
            const pattern = /^[a-zA-Z0-9]+$/;
            return pattern.test(str);
        },
        isNumeric: function(str) {
            const pattern = /^[0-9]+$/;
            return pattern.test(str);
        },
        isZip: function(str) {
            const pattern = /^\d{3}-\d{4}$/;
            return pattern.test(str);
        },
        isEmail: function(str) {
            const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return pattern.test(str);
        },
        isUrl: function(str) {
            try {
                new URL(str);
            } catch (err) {
                return false; 
            }
            // httpかhttpsではじまるか
            if( !(str.startsWith("http://") || str.startsWith("https://"))) {
                return false;
            }
            // プロトコル以下の文字列に.を1つ以上含むか
            if( !str.replace('http://','').replace('https://','').slice(1, -1).includes(".")) {
                return false;
            }
            return true;
        },
    }
}
